import { Bounce, TweenMax } from 'gsap';
import Core from '../../../../Core/Core';
import { Collection } from '../../../../Tiles/TileSet';
import { createOutlineText } from '../../../../Utils/Utils';
import { UIButton } from '../../../Shared/Buttons/UIButton';
import { RadioGroupEvents } from '../../../Shared/RadioGroup/RadioGroup';
import { RadioGroupItem } from '../../../Shared/RadioGroup/RadioGroupItem';
import { IScrollViewItem } from '../../../Shared/ScrollView/IScrollViewItem';
import { CollectablesProgressBar } from './CollectablesProgressBar';

export class CollectableRadioGroupItem extends RadioGroupItem implements IScrollViewItem {
    public readonly progressbar: CollectablesProgressBar;
    public readonly collection: Collection;
    private readonly bg: PIXI.Container;
    private readonly overlay: PIXI.Container;
    private checkMark: PIXI.Sprite;

    constructor(collection: Collection, progress: number) {
        super();
        const bgId = 'mapui/scrapbook-bg-' + collection;
        this.collection = collection;
        const bg = (this.bg = new PIXI.Sprite(PIXI.utils.TextureCache[bgId]));
        bg.anchor.set(0.5);
        const title = createOutlineText(
            Core.local.getText(collection),
            new PIXI.Rectangle(0, 0, bg.width, bg.height),
            'Baloo',
            27,
            27
        );
        title.y -= (0.8 * bg.height) / 2;

        this.addChild(bg);

        const unlocked = progress === 100;
        if (!unlocked && collection !== Collection.COMING_SOON) {
            const progressBar = (this.progressbar = new CollectablesProgressBar(
                progress,
                bg.width / 1.5,
                bg.height / 7,
                collection
            ));
            progressBar.y += (0.75 * bg.height) / 2;
            this.addChild(progressBar);
        }

        const questionMarkButton = new UIButton('mapui/scrapbook-button-info');
        questionMarkButton.x += (0.9 * bg.width) / 2;
        questionMarkButton.y -= (0.7 * bg.height) / 2;

        const overlay = (this.overlay = createOutlineText(
            Core.local.getText('FindTileTokens').replace('\\n', '\n'),
            new PIXI.Rectangle(0, 0, bg.width, bg.height),
            'Baloo',
            20,
            27
        ));
        overlay.alpha = 0;

        //@ts-ignore
        this.addChild(overlay, questionMarkButton, title);

        if (unlocked) {
            const checkMark = (this.checkMark = new PIXI.Sprite(
                PIXI.utils.TextureCache['mapui/checkmark-empty']
            ));
            checkMark.anchor.set(0.5, 0.5);
            checkMark.x = (0.9 * bg.width) / 2;
            checkMark.y = (0.7 * bg.height) / 2;
            this.addChild(checkMark);
        }

        questionMarkButton.on('trigger', this.fadeOverlay.bind(this));
        bg.on('pointerup', () => {
            if (unlocked) {
                this.emit(RadioGroupEvents.SELECTED);
            }
        });

        this.setDragging(false);
    }

    public setSelected(selected: boolean) {
        super.setSelected(selected);
        const { checkMark, bg } = this;
        if (checkMark) {
            checkMark.texture =
                PIXI.utils.TextureCache[
                    'mapui/' + (selected ? 'scrapbook-selection-rim' : 'checkmark-empty')
                ];
            if (!TweenMax.isTweening(checkMark.scale)) {
                TweenMax.to(checkMark.scale, 0.2, {
                    x: 1.01,
                    y: 1.01,
                    ease: Bounce.easeInOut,
                    repeat: 1,
                    yoyo: true,
                });
            }

            checkMark.anchor.set(0.5, 0.5);
            checkMark.x = selected ? 0 : (0.9 * bg.width) / 2;
            checkMark.y = selected ? 0 : (0.7 * bg.height) / 2;
        }
    }

    public setDragging(dragging: boolean): void {
        this.bg.interactive = this.bg.buttonMode = !dragging;
    }

    private fadeOverlay() {
        const targetAlpha = this.overlay.alpha > 0 ? 0 : 1;
        const bgTargetAlpha = targetAlpha === 1 ? 0.3 : 1;
        TweenMax.to(this.overlay, 0.2, { alpha: targetAlpha });
        TweenMax.to(this.bg, 0.2, { alpha: bgTargetAlpha });
    }
}
